import Layout from "@/layout";

export default {
  path: "/message",
  component: Layout,
  redirect: "/message/index",
    children: [
        {
            path: "index",
            name: "message",
            component: () => import(/* webpackChunkName: "message" */ "@/im"),
            meta: {
                title: "Messaging",
                icon: "message-v2"
            }
        }
    ]
}